import { RecordType, VehicleBodyTypes, VehicleMakeTypes } from '../constants/parameters';
import { LPRSharingDataScope } from './common/lpr-sharing-data-scope';

export enum AxonVISortOrder {
  CAPTURE_TIME_ASC = 'captureTime asc',
  CAPTURE_TIME_DESC = 'captureTime desc',
  PLATE_NUMBER_ASC = 'plateNumber asc',
  PLATE_NUMBER_DESC = 'plateNumber desc',
  RECORD_TYPE_ASC = 'recordType asc',
  RECORD_TYPE_DESC = 'recordType desc',
}

export enum AxonVIRecordType {
  ALL = 'all',
  HIT = 'hit',
  READ = 'read',
}

export const RECORD_TYPE_TO_AXON_VI_RECORD_TYPE: Record<RecordType, AxonVIRecordType> = {
  [RecordType.ALL]: AxonVIRecordType.ALL,
  [RecordType.HIT]: AxonVIRecordType.HIT,
};

/**
 * TODO: Update this once we have the backend working.
 * Interface for Axon VI LPR search parameters.
 *
 * Backend:
 * - Path: src/integrations/connectors/axon/fleet_ps/serializers.py
 * - Class: PlateSearchSerializer
 */
export interface IFsLprAxonVIParameters {
  includeFacets?: boolean;
  // Pagination/sorting
  sort?: AxonVISortOrder;
  sortValues?: string; // {timestamp,uuid}
  limit?: string;

  // General
  plate?: string;
  fromDate?: string;
  toDate?: string;
  searchReason: string;
  dataScope?: LPRSharingDataScope;

  // CameraRequest (TODO: see if we can enum this)
  cameraNames?: string; // comma separated camera names
  cameraModels?: string; // comma separated camera models
  cameraVendor?: string; // comma separated camera vendors
  cameraVendors?: string; // comma separated camera vendors (plural, for SDM)

  // Additional
  recordType?: AxonVIRecordType;
  assignedUserIds?: string; // comma separated user IDs

  subdivisionCode?: string;
  subdivisionConfidence?: number;
  /**
   * commas seperated polygon. fleet supports up to 20 points
   * @url https://axon.quip.com/XNl4AMLfwayD/ALPR-Provider-Geo-Search-Limitations#temp:C:SJb8b46a8ad6c604d3aa50fea1a1
   */
  inBbox?: string;
  vehicleColor?: string; // comma separated VehicleColorTypes
  vehicleMake?: VehicleMakeTypes;
  vehicleBody?: VehicleBodyTypes;
  vehicleName?: string;
  topRack?: boolean;
  windowStickers?: boolean;
  bumperStickers?: boolean;
}
